/*eslint no-template-curly-in-string: "off"*/
/*eslint sort-keys: "off"*/

const en = {
  ok: 'OK',
  arr: 'All rights reserved',
  faq: 'FAQ',
  sww: 'Something went wrong',
  back: 'Back',
  city: 'City',
  iban: 'IBAN',
  name: 'Name',
  scan: 'Scan',
  user: 'User',
  apply: 'Apply',
  email: 'Email address',
  error: 'Error',
  login: 'Login',
  state: 'State',
  abartn: 'ACH Routing Number',
  cancel: 'Cancel',
  failed: 'Failed',
  resend: 'Resend Code',
  search: 'Search',
  signUp: 'Sign up',
  submit: 'Submit',
  update: 'Update',
  LB_0102: 'Wrong password',
  RS_0001: 'Something went wrong',
  aboutUs: 'About us',
  account: 'Account',
  addCity: 'Please provide a city!',
  addIban: 'The IBAN number is incorrect',
  address: 'Address',
  current: 'Current',
  deposit: 'Deposit',
  loopApp: 'Download Loop app',
  pending: 'Pending',
  savings: 'SAVINGS',
  signOut: 'Sign out',
  sorting: 'Sorting',
  success: 'Success',
  warning: 'Warning',
  yourPsw: 'Your password',
  zipCode: 'ZIP Code',
  addState: 'Please provide a state!',
  allTypes: 'All types',
  bankCode: 'Bank Code',
  checking: 'CHECKING',
  codeSent: 'We sent a 4 digit code to your email address:',
  fullName: 'Full name',
  keepItUp: 'Keep it up!',
  mistyped: 'I mistyped my email address',
  password: 'Password',
  postCode: 'Post code',
  products: 'Products',
  quantity: 'Quantity',
  register: 'Register',
  rejected: 'Rejected',
  security: 'Security',
  showMore: 'Show more',
  sortCode: 'Sort Code',
  weAreSad: 'We are sad to see you go',
  withdraw: 'Withdraw',
  addAbartn: 'Please make sure your ACH routing number is correct!',
  allStatus: 'All Status',
  bankAdded: 'Bank data added',
  cancelled: 'Cancelled',
  completed: 'Completed',
  contactUs: 'Contact us',
  countries: 'Countries',
  createPsw: 'Create Password',
  enterName: 'Please enter your name',
  forgotPsw: 'Forgot my password',
  maxAmount: 'Maximum amount is your current balance',
  onlyEmail: 'Email',
  addAddress: 'Please provide address!',
  adjustment: 'Customer care adjustment',
  allBinType: 'All bin type',
  branchCode: 'Branch Code',
  confirmNow: 'Confirm now',
  currentPsw: 'Current password',
  helloWorld: 'Hello World',
  howItWorks: 'How it works',
  linkSentTo: 'We have sent your password recovery link to:',
  resendCode: 'Resend confirmation code',
  shopReturn: 'Shop & return',
  updateUser: 'Update user',
  updatedPsw: 'Password successfully updated',
  withdrawal: 'Withdrawal',
  acceptTheTC: 'Please accept the terms and conditions',
  accountName: 'Account name',
  accountType: 'Account type',
  addBankCode: 'Please add your Bank Code',
  addPostCode: 'Please provide a post code!',
  almostThere: 'You are almost there.',
  companyName: 'TerraCycle - Loop',
  deleteTitle: 'Oops!',
  enterNewPsw: 'Please enter a new password',
  loginFailed: 'Login failed',
  newPassword: 'New password',
  payPalEmail: 'Your PayPal email',
  pendingText: 'This item has been scanned and added to your Loop account. If you have not yet dropped it into a Loop Return Point, please do so. Deposits will be credited to your account as soon as the item arrives at our cleaning facility, and can take up to 32 days to process.',
  profilePage: 'Profile',
  sendRequest: 'Send my request',
  setUpPaypal: 'Set up PayPal',
  alreadyTaken: 'Email has already been taken',
  confirmEmail: 'Confirm your email address',
  confirmLater: 'Confirm later',
  createdAtASC: 'Created at ASC',
  enterYourPsw: 'Please enter your password',
  incorrectPsw: 'Current password is incorrect',
  loopLocation: 'Where are you located?',
  noItemToShow: 'No item to show',
  notValidated: 'Please validate your email! You can not do withdrawal request without email validation.',
  personalData: 'Personal data',
  recoverySent: 'We have sent your password recovery link.',
  rejectedItem: 'Return rejected',
  sendRecovery: 'Send password recovery email',
  signUpFailed: 'Sign up failed',
  wantToReturn: 'Want to return your empty container?',
  withdrawType: 'Withdraw method',
  accountNumber: 'Account number: ',
  addBranchCode: 'Add branch code',
  cancelledItem: 'Cancelled scan',
  checkProducts: 'Check out available products',
  choosePayment: 'Choose Payment Method',
  confirmDelete: 'Please confirm that you understand this action is irreversible.',
  confirmNewPsw: 'Confirm new password',
  createdAtDESC: 'Created at DESC',
  emailVerified: 'Your email address is successfully verified.',
  enterPostCode: 'Please enter your postcode',
  enterValidPsw: 'Please enter a valid password',
  enterYourName: 'Please enter your name!',
  lastFourDigit: 'Last 4 digits of phone number',
  locationTitle: 'Shop & Return',
  noBalanceText: 'No need to clean, sort and throw out single-use packaging - just scan and return your used packaging so that it can be cleaned and reused. That\'s less effort for you, and less waste for our planet.',
  noTransaction: 'You have now balance history yet.',
  passwordError: 'Password should be at least 8 characters long',
  payPalDetails: 'PayPal details',
  pswChangeFail: 'Password change failed',
  pswDoNotMatch: 'Passwords do not match',
  selectCountry: 'Select a country',
  sendMeTheCode: 'Send me the code',
  transitNumber: 'Transit Number',
  weSentTheCode: 'We sent the code to this email address:',
  zipInputEmpty: 'Please provide a zip code!',
  zipInputError: 'Zip code must be minimum 5 characters.',
  addAccountType: 'Please enter your account type',
  bankAccountSub: 'Fill in your bank account details to receive your deposit refund via bank transfer.',
  changePassword: 'Change password',
  checkYourInbox: 'Check your inbox',
  cookieSettings: 'Cookie Settings',
  currentBalance: 'Your current balance is: ',
  deleteUserText: 'We\'re sorry to see you go. If you wish to delete your account, please be aware that this action is irreversible and all associated data will be permanently removed.',
  downloadTheApp: 'Please <1>download our app</1> to perform returns at the stores.',
  nameInputEmpty: 'Please provide a name!',
  noBalanceTitle: 'You have no balance history yet.',
  paymentDetails: 'Payment details',
  pendingRequest: 'You still have pending withdrawal request or QR scan. Contact Customer Service with your account deletion request.',
  returnItem_one: '{{count}} Item Returned',
  selectCategory: 'Select Category',
  selectRetailer: 'Select Retailer',
  withdrawAmount: 'Please enter your withdraw amount',
  alreadyUsedLink: 'This password link has already been used',
  deleteMyAccount: 'Delete my account',
  editBankAccount: 'Bank account:',
  emailInputEmpty: 'Please provide an email!',
  emailInputError: 'The input is not valid email!',
  enterCurrentPsw: 'Please enter your current password',
  enterValidEmail: 'Pleaser enter a valid email',
  loopLocationSub: 'Loop is currently only available in these countries:',
  pendingItem_one: '{{count}} Item Pending Check-in',
  returnALoopItem: 'Return a Loop item and start tracking your impact here!',
  startNavigation: 'Start navigation',
  weDontRecognise: 'Sorry, we don\'t recognise this code.',
  youHaveReturned: 'You have returned',
  accountPageTitle: 'Account',
  addAccountNumber: 'Enter your account number',
  adjustmentSelect: 'Adjustment',
  deleteHasBalance: 'You still have a positive balance. You must withdraw it before deleting your account.',
  enterNewPassword: 'Enter your new password',
  fixTransitNumber: 'Please make sure your transit number is correct!',
  locationSubTitle: 'Find your nearest pick up point',
  marketingConsent: 'Keep me in the loop about upcoming launches, updates  and special offers.',
  pendingTextTitle: 'Item pending check-in',
  pleaseInputDigit: 'Please enter the 4 digits!',
  profilePageTitle: 'Profile',
  pswChracterError: 'New password must be at least 8 characters long',
  returnItem_other: '{{count}} Items Returned',
  setUpBankAccount: 'Set up Bank account',
  addValidAchNumber: 'Please enter a valid 9-digit ACH Routing number',
  bankAccountNumber: 'Bank account number',
  changedSuccessful: 'Your personal data saved successfully',
  clickHereToVerify: 'Click here to verify your email.',
  deleteRequestText: 'Enter your password to send a request to Customer Service to delete your account.',
  editPayPalAccount: 'Paypal:',
  enterEmailAddress: 'Enter the email address associated with your account',
  institutionNumber: 'Institution Number',
  loopSomethingElse: 'Want to Loop something else?',
  manageYourBalance: 'Manage your balance and request withdrawals!',
  pendingItem_other: '{{count}} Items Pending Check-in',
  pendingWithdrawal: 'Pending withdrawal',
  requestWithdrawal: 'Request withdrawal',
  sendRecoveryEmail: 'We will send your recovery email here.',
  willSendDigitCode: 'We will send a 4 digit code to:',
  accountBalance_one: 'You have {{count}} item pending check-in. Deposits get credited once items reach our cleaning facility.',
  achNumberTypeError: 'Please enter a valid ACH Routing number consisting of only numbers.',
  bankAccountDetails: 'Bank Account details',
  confirmNewPswError: 'Please confirm your new password',
  enterAccountNumber: 'Please enter your account number',
  enterValidPostCode: 'The entered ZIP code is invalid.',
  exploreYourAccount: 'Explore your account',
  loginFailedMessage: 'The email or password is incorrect.',
  payPalCheckboxText: 'All of your withdrawals will be sent to your PayPal account.',
  pleaseEnterTheCode: 'Please enter the confirmation code sent to your email address:',
  termsAndConditions: 'I accept the <1>Terms & Conditions and the Privacy Policy</1> I also confirm that I am over 16 years of age.',
  cancelledWithdrawal: 'Cancelled withdrawal',
  choosePaymentMethod: 'Choose Payment Method',
  containerReUsed_one: 'You have returned <1>slotMachine</1> container to be reused!',
  defaultPaymentSaved: 'Default payment saved',
  deleteAccountSucces: 'Your account has been deleted. We hope to see you again soon.',
  payPalModalSubtitle: 'Enter the email address associated with your PayPal account to receive your deposit refund via PayPal.',
  accountBalance_other: 'You have {{count}} items pending check-in. Deposits get credited once items reach our cleaning facility.',
  codeSentNotification: 'We sent a 4 digit code to your email address!',
  enterAccountSortCode: 'Please enter your account sort code',
  fixInstitutionNumber: 'Please make sure your institution number is correct!',
  paymentCheckboxTitle: 'Default payment method',
  personalDataSubtitle: 'If you need to change your email address or ZIP code, please contact our Customer Care.',
  withdrawConfirmation: 'Withdraw confirmation',
  addValidAccountNumber: 'Please enter a valid account number of between 6 and 17 digits.',
  adjustmentDescription: 'Balance adjustment by Loop Customer Service.',
  containerReUsed_other: 'You have returned <1>slotMachine</1> containers to be reused!',
  deleteCheckboxConfirm: 'I am aware that this action is irreversible and all associated data will be permanently removed.',
  deleteHasBalanceTitle: 'Oops!',
  enterValidPhoneDigits: 'Please enter the last 4 digits of your phone number',
  marketResearchConsent: 'I am interested in helping Loop and partners create a zero waste future by sharing my input and feedback.',
  termsAndConditionsBtn: 'Terms and condition and Privacy Policy',
  accountNumberTypeError: 'Please enter a valid account number consisting of only numbers.',
  beforeWithdrawValidate: 'Before making your first withdrawal, please confirm your email address.',
  contactCustomerSupport: 'To change the email address please contact our Customer Support',
  paymentDetailsSubtitle: 'All of your withdrawals will be sent to your bank account.',
  withdrawAmountOnConfrim: 'Withdraw amount',
  minimumWithdrawalAmmount: '{{value}} minimum withdrawal amount',
  deleteAccountRequestSucces: 'We have received your account deletion request and will be in touch.',
}

const fr = {
  ok: 'OK',
  arr: 'Tous droits réservés',
  faq: 'Informations complémentaires',
  sww: 'Un problème est survenu',
  back: 'retour',
  city: 'Ville',
  iban: 'IBAN',
  name: 'Prénom et Nom',
  scan: 'Scan',
  user: 'Utilisateur',
  apply: 'Valider',
  email: 'E-mail',
  error: 'Erreur',
  login: 'Se connecter',
  state: 'Région',
  abartn: 'Numéro IBAN',
  cancel: 'Annuler',
  failed: 'Echec',
  resend: 'Renvoyer le code de confirmation',
  search: 'Rechercher',
  signUp: 'S\'inscrire',
  submit: 'Confirmer',
  update: 'Mise à jour',
  LB_0102: 'bad bad bad',
  RS_0001: 'Un problème est survenu',
  aboutUs: 'À propos de nous',
  account: 'Compte',
  addCity: 'Please provide a city!',
  addIban: 'Le numéro IBAN est incorrect',
  address: 'Addresse',
  current: 'Current',
  deposit: 'Consigne :',
  loopApp: 'Téléchargez l\'application',
  pending: 'Attente',
  savings: 'ECONOMIES',
  signOut: 'Déconnexion',
  sorting: 'Tri',
  success: 'Validé !',
  warning: 'Attention',
  yourPsw: 'Votre mot de passe',
  zipCode: 'Code postal',
  addState: 'Veuillez renseigner une région!',
  allTypes: 'Tous types',
  bankCode: 'Bank Code',
  checking: 'Enregistrer',
  codeSent: 'Nous enverrons un code à 4 chiffres à',
  fullName: 'Nom et prénom',
  keepItUp: 'Bravo !',
  mistyped: 'J\'ai mal tapé mon adresse e-mail',
  password: 'Mot de passe',
  postCode: 'Code postal',
  products: 'Produits Disponibles',
  quantity: 'Quantité',
  register: 'S\'inscrire',
  rejected: 'Rejeté',
  security: 'Sécurité',
  showMore: 'Voir plus',
  sortCode: 'Sort Code',
  weAreSad: 'Nous sommes triste de vous voir partir',
  withdraw: 'Transférer',
  addAbartn: 'Veuillez vérifier votre numéro IBAN !',
  allStatus: 'Tous status',
  bankAdded: 'Données bancaires ajoutées',
  cancelled: 'Annulé',
  completed: 'Complété',
  contactUs: 'Nous contacter',
  countries: 'Countries',
  createPsw: 'Créer un mot de passe',
  enterName: 'Veuillez entrer votre prénom et nom',
  forgotPsw: 'Mot de passe oublié',
  maxAmount: 'Le montant maximal est votre solde actuel',
  onlyEmail: 'E-mail',
  addAddress: 'Veuillez renseigner votre adresse!',
  adjustment: 'Ajustement service client',
  allBinType: 'Distributeurs',
  branchCode: 'Branch Code',
  confirmNow: 'Confirmer maintenant',
  currentPsw: 'Ancien mot de passe',
  helloWorld: 'Fr Hello World',
  howItWorks: 'Comment ça marche',
  linkSentTo: 'Nous avons envoyé un lien de réinitialisation de mot de passe à',
  resendCode: 'Renvoyer le code de confirmation',
  shopReturn: 'Carte',
  updateUser: 'Mettre à jour',
  updatedPsw: 'Le mot de passe a bien été mis à jour',
  withdrawal: 'Virement',
  acceptTheTC: 'Veuillez accepter les termes et conditions',
  accountName: 'Fr Account name',
  accountType: 'Type de compte',
  addBankCode: 'Please add your Bank Code',
  addPostCode: 'Veuillez renseigner un code postal!',
  almostThere: 'Vous y êtes presque',
  companyName: 'TerraCycle',
  deleteTitle: 'Oops!',
  enterNewPsw: 'Veuillez entrer votre nouveau mot de passe',
  loginFailed: 'La connexion a échoué, veuillez réessayer',
  newPassword: 'Nouveau Mot de Passe',
  payPalEmail: 'Votre e-mail PayPal',
  paypalEmail: 'Votre e-mail PayPal',
  pendingText: 'Cet article a été scanné et ajouté à votre compte Loop. Si vous ne l\'avez pas encore déposé dans un espace de collecte, veuillez le faire. Votre compte sera crédité du montant de la consigne dès son arrivée à notre centre de tri, généralement dans les 2 à 8 jours suivant son dépôt.Nous vous invitions à contacter notre service client, si vous avez un problème de remboursement : Email: infofr@loopmobileapp.com',
  profilePage: 'Profile',
  sendRequest: 'Envoyer ma demande',
  setUpPaypal: 'Configurer PayPal',
  addValidIban: 'Please enter a valid IBAN number between 14 and 34 digits.',
  alreadyTaken: 'FR Email has already been taken',
  confirmEmail: 'Confirmez votre adresse e-mail',
  confirmLater: 'Confirmer plus tard',
  createdAtASC: 'Ajout Croisant',
  enterYourPsw: 'Veuillez entrer votre mot de passe',
  incorrectPsw: 'Votre mot de passe est incorrect',
  loopLocation: 'Où êtes-vous situé(e) ?',
  noItemToShow: 'Pas d\'articles disponibles',
  notValidated: 'Avant d\'effectuer votre premier virement, veuillez confirmer votre adresse e-mail.',
  personalData: 'Données personnelles',
  recoverySent: 'Nous avons envoyé un lien de réinitialisation de mot de passe.',
  rejectedItem: 'Retour rejeté',
  sendRecovery: 'Envoyer un e-mail de réinitialisation',
  signUpFailed: 'Echec d\'identification',
  wantToReturn: 'Prêt à retourner ?',
  withdrawType: 'Méthode de virement',
  accountNumber: 'Numéro IBAN : ',
  addBranchCode: 'Add branch code',
  cancelledItem: 'Scan annulé',
  checkProducts: 'Consultez le catalogue Loop',
  choosePayment: 'Veuillez choisir un moyen de paiement',
  confirmDelete: 'Veuillez confirmer être conscient que cette action est irréversible.',
  confirmNewPsw: 'Confirmer votre nouveau Mot de Passe',
  createdAtDESC: 'Ajout décroissant',
  emailVerified: 'Votre adresse e-mail a bien été confirmée.',
  enterPostCode: 'Veuillez entrer votre code postal',
  enterValidPsw: 'Veuillez vous assurer que votre mot de passe comporte au moins 8 caractères',
  enterYourName: 'Veuillez entrer votre nom!',
  lastFourDigit: 'Last 4 digits of phone number',
  locationTitle: 'Localisation',
  noBalanceText: 'Il semblerait que vous n\'avez pas encore rapporté de produits Loop. Achetez-en dès maintenant dans un magasin près de chez vous.',
  noTransaction: 'Votre solde est épuisé pour le moment',
  passwordError: 'Votre mot de passe doit compter au minimum 8 caractères',
  payPalDetails: 'Détails PayPal',
  pswChangeFail: 'Echec de changement de Mot de Passe',
  pswDoNotMatch: 'Le Mot de Passe ne correspond pas',
  selectCountry: 'Sélectionner un pays',
  sendMeTheCode: 'Envoyez-moi le code',
  transitNumber: 'Transit Number',
  weSentTheCode: 'Nous avons envoyé le code à cette adresse email',
  zipInputEmpty: 'Veuillez entrer votre code postal',
  zipInputError: 'Le format de code postal n\'est pas valide',
  addAccountType: 'Veuillez entrer votre type de compte',
  bankAccountSub: 'Entrez les détails de votre compte bancaire pour recevoir un remboursement par virement bancaire.',
  changePassword: 'Changer mon mot de passe',
  checkYourInbox: 'Vérifiez votre boîte de réception',
  cookieSettings: 'Paramètre des Cookies',
  currentBalance: 'Votre solde Loop actuel',
  deleteUserText: 'Nous sommes désolés de vous voir partir. Si vous souhaitez supprimer votre compte, veuillez noter que cette action est irréversible et toutes les données associées seront retirées définitivement.',
  downloadTheApp: 'Téléchargez notre application mobile pour retourner vos contenants en magasin.',
  nameInputEmpty: 'Veuillez entrer votre prénom et nom',
  noBalanceTitle: 'Votre solde est épuisé pour le moment',
  paymentDetails: 'Détails de paiement',
  pendingRequest: 'Il semble que vous ayez de l\'argent sur votre compte Loop ou un scan en attente.',
  returnItem_one: '{{count}} Article rapporté',
  selectCategory: 'Catégories disponibles',
  selectRetailer: 'Magasins participants',
  withdrawAmount: 'Montant à transférer',
  alreadyUsedLink: 'Ce lien de mot passe a déjà été utilisé',
  deleteMyAccount: 'Supprimer mon compte',
  editBankAccount: 'Modifier',
  emailInputEmpty: 'Veuillez entrer votre adresse e-mail',
  emailInputError: 'Le format de votre adresse e-mail n\'est pas valide',
  enterCurrentPsw: 'Veuillez entrer votre ancien mot de passe',
  enterValidEmail: 'Veuillez entrer votre adresse e-mail',
  loopLocationSub: 'Loop est actuellement disponible dans ces pays',
  pendingItem_one: '{{count}} Article en attente de validation',
  returnALoopItem: 'Rapportez un article Loop et suivez votre impact ici !',
  startNavigation: 'Commencer la navigation',
  weDontRecognise: 'Désolé, nous ne reconnaissons pas ce code.',
  youHaveReturned: 'Vous avez rapporté',
  accountPageTitle: 'Compte',
  addAccountNumber: 'Enter your account number',
  adjustmentSelect: 'Ajustement',
  deleteHasBalance: 'Vous avez un solde restant positif. Vous devez procédez au retrait de ce dernier avant de suppromer votre compte',
  enterNewPassword: 'Veuillez entrer le nouveau mot de passe',
  fixTransitNumber: 'Please make sure your transit number is correct!',
  locationSubTitle: 'Trouvez le magasin participant le plus proche',
  marketingConsent: 'Tenez-moi au courant des prochains lancements, mises à jour et offres spéciales.',
  pendingTextTitle: 'Article en attente de validation',
  pleaseInputDigit: 'Veuillez renseigner votre code!',
  profilePageTitle: 'Profile',
  pswChracterError: 'Veuillez vous assurer que votre mot de passe comporte au moins 8 caractères',
  returnItem_other: '{{count}} Articles rapportés',
  setUpBankAccount: 'Configurer Compte Bancaire',
  bankAccountNumber: 'Numéro IBAN',
  changedSuccessful: 'Vos données personnelles ont été sauvegardées avec succès',
  clickHereToVerify: 'Clickez ici pour vérifier votre adresse email.',
  deleteRequestText: 'Enter your password to send a request to Customer Service to delete your account.',
  editPayPalAccount: 'Modifier les informations PayPal',
  enterEmailAddress: 'Veuillez saisir l\'adresse e-mail associée à votre compte',
  institutionNumber: 'Institution Number',
  loopSomethingElse: 'Prêt pour votre prochaine boucle ?',
  manageYourBalance: 'Gérez votre compte et consultez votre solde!',
  pendingItem_other: '{{count}} Articles en attente de validation',
  pendingWithdrawal: 'Virement en cours',
  requestWithdrawal: 'Demander un retrait',
  sendRecoveryEmail: 'Nous vous enverrons un e-mail pour réinitialiser votre mot de passe.',
  willSendDigitCode: 'Nous enverrons un code à 4 chiffres à',
  accountBalance_one: 'Vous avez {{count}} article(s) en attente de validation. Votre compte sera crédité une fois que nous aurons collecté et trié les contenants retournés.',
  bankAccountDetails: 'Coordonnées bancaires',
  confirmNewPswError: 'Veuillez confirmer votre nouveau Mot de Passe',
  enterAccountNumber: 'Veuillez entre votre numéro de compte',
  enterValidPostCode: 'FR The entered ZIP code is invalid.',
  exploreYourAccount: 'Découvrer votre compte',
  loginFailedMessage: 'L\'adresse email ou le Mot de Passe est incorrect.',
  payPalCheckboxText: 'Tous vos retraits seront versés sur votre compte PayPal.',
  pleaseEnterTheCode: 'Veuillez saisir le code de confirmation envoyé à votre adresse e-mail',
  termsAndConditions: 'J\'accepte <1>conditions d\'utilisation et la politique de confidentialité</1>',
  cancelledWithdrawal: 'Annuler le retrait',
  choosePaymentMethod: 'Choisissez un moyen de paiement',
  containerReUsed_one: 'Vous avez rapporté<1>slotMachine</1> contenant pour être réutilisé !',
  defaultPaymentSaved: 'Moyen de paiement par défaut enregistré',
  deleteAccountSucces: 'Votre compte a été supprimé. Nous espérons vous revoir bientôt.',
  payPalModalSubtitle: 'Saisissez l\'adresse e-mail associée à votre compte PayPal pour recevoir le remboursement via PayPal.',
  accountBalance_other: 'Vous avez {{count}} article(s) en attente de validation. Votre compte sera crédité une fois que nous aurons collecté et trié les contenants retournés.',
  codeSentNotification: 'Nous vous avons envoyé un code à 4 chiffre par email!',
  enterAccountSortCode: 'Veuillez saisir le code de réinitialisation de compte',
  fixInstitutionNumber: 'Please make sure your institution number is correct!',
  paymentCheckboxTitle: 'Mode de paiement par défaut',
  personalDataSubtitle: 'Si vous devez modifier votre adresse e-mail, veuillez contacter notre service client.',
  withdrawConfirmation: 'Confirmation de retrait',
  addValidAccountNumber: 'Veuillez saisir un numéro de compte valide, entre 4 and 17 numéros.',
  adjustmentDescription: 'Ajustement service client',
  containerReUsed_other: 'Vous avez rapporté<1>slotMachine</1> contenant pour être réutilisé !',
  deleteCheckboxConfirm: 'Je confirme être au courant que cette action est irréversible et toutes les données associées seront définitivement retirées.',
  deleteHasBalanceTitle: 'Oops!',
  enterValidPhoneDigits: 'Please enter the last 4 digits of your phone number',
  marketResearchConsent: 'Je souhaite aider Loop et ses partenaires à créer un monde sans déchets en partageant mon opinion.',
  termsAndConditionsBtn: 'Conditions d\'utilisation et politique de confidentialité',
  accountNumberTypeError: 'Veuillez saisir un numéro de compte valide, composé uniquement de chiffres.',
  beforeWithdrawValidate: 'Avant d\'effectuer votre premier virement, veuillez confirmer votre adresse e-mail.',
  contactCustomerSupport: 'Si vous devez modifier votre adresse e-mail, veuillez contacter notre service client.',
  paymentDetailsSubtitle: 'Tous vos retraits seront versés sur votre compte bancaire.',
  withdrawAmountOnConfrim: 'Retiré le montant',
  minimumWithdrawalAmmount: 'Le montant minimum est de {{value}}',
  deleteAccountRequestSucces: 'Nous avons reçu votre demande de suppréssion de compte et nous vous tiendrons au courant de la suite',
}

const ja = {
  ok: 'OK',
  arr: 'All rights reserved',
  faq: 'FAQ（よくある質問)',
  sww: '二次元バーコードを正しく処理できません',
  back: '戻る',
  city: 'City',
  iban: 'IBAN',
  name: '氏名',
  scan: '返却',
  user: 'User',
  apply: '決定',
  email: 'メールアドレス',
  error: 'エラーが発生しました。',
  login: 'ログイン',
  state: 'State',
  abartn: 'ACH Routing Number',
  cancel: 'キャンセル',
  failed: '失敗しました',
  resend: '認証コードを再送する',
  search: '検索',
  signUp: 'アカウント登録する',
  submit: '次へ',
  update: '更新する',
  LB_0102: 'パスワードが無効です',
  RS_0001: '二次元バーコードを正しく処理できません',
  aboutUs: 'Loopについて',
  account: '残高',
  addCity: 'Please provide a city!',
  addIban: 'The IBAN number is incorrect',
  address: 'Address',
  current: '普通',
  deposit: '預り金',
  loopApp: 'アプリダウンロード',
  pending: '手続き中',
  savings: '貯蓄',
  signOut: 'ログアウト',
  sorting: '並び替え',
  success: '送信完了',
  warning: 'Warning',
  yourPsw: 'お客様のパスワード',
  zipCode: 'お住まいの郵便番号',
  addState: 'Please provide a state!',
  allTypes: '全て',
  bankCode: '銀行名',
  checking: '当座',
  codeSent: '四桁のコードを送信します',
  fullName: '氏名は必須項目です',
  keepItUp: 'ありがとうございます！',
  mistyped: 'メールアドレスを間違えた場合',
  password: 'パスワード',
  postCode: 'お住まいの郵便番号',
  products: '商品カタログ',
  quantity: '容器数',
  register: 'アカウント登録する',
  rejected: '拒否されました',
  security: 'セキュリティ',
  showMore: 'もっと見る',
  sortCode: '【確認】',
  weAreSad: 'さようなら... :(',
  withdraw: '払い出し',
  addAbartn: 'Please make sure your ACH routing number is correct!',
  allStatus: 'ステータス',
  bankAdded: '銀行情報が追加されました',
  cancelled: 'キャンセルされました',
  completed: '完了しました',
  contactUs: 'お問い合わせ',
  countries: 'Countries',
  createPsw: 'パスワードを入力する',
  enterName: '氏名を入力してください',
  forgotPsw: 'パスワードを変更',
  maxAmount: '残高が最大値です',
  onlyEmail: 'メールアドレス',
  addAddress: 'Please provide address!',
  adjustment: 'ｶｽﾀﾏｰｻｰﾋﾞｽによる調整',
  allBinType: '全ての返却拠点',
  branchCode: '銀行支店名',
  confirmNow: '今すぐ認証する',
  currentPsw: '旧パスワード',
  helloWorld: 'Hello World',
  howItWorks: 'Loopの利用方法',
  linkSentTo: 'パスワード再発行用のリンクをこちらのメールアドレスへ送信いたしました',
  resendCode: '認証コードを再送する',
  shopReturn: 'マップ',
  updateUser: '更新',
  updatedPsw: 'パスワードが更新されました',
  withdrawal: '払い出し',
  acceptTheTC: '利用規約に同意してください',
  accountName: '口座名義（カタカナ)',
  accountType: '口座種別',
  addBankCode: '銀行コードが無効です',
  addPostCode: 'お住まいの郵便番号',
  almostThere: '＜ご対応ください＞',
  companyName: 'TerraCycle',
  deleteTitle: 'Oops!',
  enterNewPsw: '新しいパスワードを入力してください',
  loginFailed: 'ログインに失敗しました。再試行してください',
  newPassword: '新パスワード',
  payPalEmail: '口座の登録電話番号（ハイフンなし',
  paypalEmail: 'PayPalアカウントのメールアドレス',
  pendingText: '本容器は二次元バーコードの読み取りが完了し、残高ページに情報が反映されています。容器は返却ボックスへ入れてください。容器が洗浄施設へ到着しましたら、残高に預り金額が反映されます。（ご返却後、Loop残高の反映まで2週間程度かかる場合があります。',
  profilePage: 'マイアカウント',
  sendRequest: 'リクエストを送信する',
  setUpPaypal: 'を利用する',
  alreadyTaken: 'JP Email has already been taken',
  confirmEmail: 'メールアドレスの認証についてs',
  confirmLater: '後で認証する',
  createdAtASC: '昇順（日付）',
  enterYourPsw: 'パスワードを入力してください',
  incorrectPsw: '正しいパスワードをご入力ください',
  loopLocation: 'お住まいの地域をご選択ください',
  noItemToShow: '該当する履歴がありません。',
  notValidated: '払い出し申請にはメールアドレスの認証が必要です',
  personalData: 'ご登録情報',
  recoverySent: 'パスワード再発行用のリンクをこちらのメールアドレスへ送信いたしました',
  rejectedItem: '拒否された返却',
  sendRecovery: 'パスワード再発行のメールを送信',
  signUpFailed: '登録が失敗しました',
  wantToReturn: '返却容器をお持ちですか？',
  withdrawType: '払い出し先',
  accountNumber: '口座番号: ',
  addBranchCode: '銀行支店コードが無効です',
  cancelledItem: 'ｶｽﾀﾏｰｻｰﾋﾞｽによるキャンセル',
  checkProducts: '商品カタログをみる',
  choosePayment: '払い出し先を選択',
  confirmDelete: 'この操作は取り消すことができません。',
  confirmNewPsw: '新しいパスワードを確認する',
  createdAtDESC: '降順（日付）',
  emailVerified: 'メールアドレスの認証が完了しました',
  enterPostCode: '郵便番号を入力してください',
  enterValidPsw: 'パスワードは8文字以上でご設定ください',
  enterYourName: '指名は必須項目です。',
  lastFourDigit: '電話番号の下４桁',
  locationTitle: '回収拠点を探そう',
  noBalanceText: '返却済み容器がないようです。',
  noTransaction: '残高履歴はございません',
  passwordError: '最低8文字以上で設定してください。',
  payPalDetails: 'Pring口座情報',
  pswChangeFail: 'パスワード変更エラー',
  pswDoNotMatch: 'パスワードが一致しません',
  selectCountry: '国を選択する',
  sendMeTheCode: '認証コードを送信する',
  transitNumber: 'Transit Number',
  weSentTheCode: '以下のメールアドレスへ送信しました:',
  zipInputEmpty: '郵便番号を入力してください',
  zipInputError: '郵便番号が無効です',
  addAccountType: '口座種別',
  bankAccountSub: '払い出し申請された額は、下記銀行口座へ振り込まれます。入力に誤りがありますと返金されない場合がございます。8800円未満の申請には手数料が249円発生します。',
  changePassword: 'パスワードを変更する',
  checkYourInbox: 'メールを送信しました',
  cookieSettings: 'クッキーの設定',
  currentBalance: '預り金残高',
  deleteUserText: 'Loopをご利用いただきありがとうございます。この操作は取り消すことができません。全てのデータが消去されることをご了承ください。',
  downloadTheApp: ' <1>Loopアプリをダウンロード</1> して店頭で容器を返却してください。',
  nameInputEmpty: '氏名を入力してください',
  noBalanceTitle: '残高履歴はございません.',
  paymentDetails: '預り金の払い出し先',
  pendingRequest: '待機中の払い出しもしくは返却申請があります。',
  returnItem_one: '返却済みの容器 {{count}}',
  selectCategory: 'カテゴリを選択',
  selectRetailer: '店舗を選択',
  withdrawAmount: '払い出し手続き額',
  alreadyUsedLink: 'このリンクはすでに利用済みです',
  deleteMyAccount: 'アカウントを削除する',
  editBankAccount: '編集',
  emailInputEmpty: 'メールアドレスを入力して下さい',
  emailInputError: 'メールアドレスが無効です',
  enterCurrentPsw: '古いパスワードを入力してください',
  enterValidEmail: 'メールアドレスを入力して下さい',
  loopLocationSub: '現在Loopは、下記の地域でご利用いただけます',
  pendingItem_one: '返却手続き中の容器 {{count}}',
  returnALoopItem: 'Loop容器を返却して あなたの環境貢献度を記録しよう！',
  startNavigation: '地図アプリを開く',
  weDontRecognise: '認証されたコードが正しくありません',
  youHaveReturned: 'あなたの返却個数',
  accountPageTitle: '残高',
  addAccountNumber: 'アカウント番号を入力してください',
  adjustmentSelect: 'ｶｽﾀﾏｰｻｰﾋﾞｽによる調整',
  deleteHasBalance: '残高が残っています。アカウント削除をする前に、残高の払い出しを完了させてください。',
  enterNewPassword: '新しいパスワードを入力してください',
  fixTransitNumber: 'Please make sure your transit number is correct!',
  locationSubTitle: '日本',
  marketingConsent: 'Loopの最新情報、新商品やキャンペーン情報をお届けします',
  pendingTextTitle: '返却手続き中の容器',
  pleaseInputDigit: '桁を入力してください',
  profilePageTitle: 'マイアカウント',
  pswChracterError: 'パスワードは8文字以上でご設定ください',
  returnItem_other: '返却済みの容器 {{count}}',
  setUpBankAccount: '銀行口座を利用する',
  accountNumberType: '無効な口座番号です',
  bankAccountNumber: '口座番号',
  changedSuccessful: '変更が更新されました',
  clickHereToVerify: 'メールアドレスを認証する',
  deleteRequestText: 'アカウント削除をご希望される場合は、パスワードを入力してください。',
  editPayPalAccount: 'PayPalの情報を編集する',
  enterEmailAddress: 'ご登録されているメールアドレスをご入力ください',
  institutionNumber: 'Institution Number',
  loopSomethingElse: '他にはどんな商品があるの？',
  manageYourBalance: '残高の確認と払い出し申請をしよう！',
  pendingItem_other: '{{count}} ｶｽﾀﾏｰｻｰﾋﾞｽによる返却手続き中',
  pendingWithdrawal: '払い出し手続き処理中',
  requestWithdrawal: '払い出し申請する',
  sendRecoveryEmail: 'パスワード再発行のメールを送信いたします',
  willSendDigitCode: '以下のメールアドレスに認証コードを送信します:',
  accountBalance_one: '返却手続き中の容器: {{count}} 容器が洗浄施設に到着しましたら残高が更新されます。',
  bankAccountDetails: '銀行口座情報を入力',
  confirmNewPswError: 'パスワードを確認してください',
  enterAccountNumber: '口座番号を入力してください',
  enterValidPostCode: 'JP The entered ZIP code is invalid.',
  exploreYourAccount: 'アカウントを確認する',
  loginFailedMessage: 'メールアドレスもしくはパスワードが間違っています',
  payPalCheckboxText: '預り金の払い出しがこちらのPring口座にされるように設定する.',
  pleaseEnterTheCode: '認証コードを入力してください',
  termsAndConditions: '利用規約とプライバシーポリシー<1>に同意する</1>',
  cancelledWithdrawal: 'キャンセルされた払い出し',
  choosePaymentMethod: '払い出し先を選択',
  containerReUsed_one: 'あなたの返却個数<1>slotMachine</1> 使い捨て容器が削減されました！',
  defaultPaymentSaved: 'デフォルトの払い出し方法が設定されました。',
  deleteAccountSucces: 'アカウントは削除されました。またのご登録をお待ちしています！',
  payPalModalSubtitle: 'PayPalアカウントへの払い出しをご希望の場合は、PayPalアカウントのメールアドレスをご入力ください。',
  accountBalance_other: '返却手続き中の容器: {{count}} 容器が洗浄施設に到着しましたら残高が更新されます。',
  codeSentNotification: '以下のメールアドレスへ送信しました:',
  enterAccountSortCode: 'Please enter your account sort code',
  fixInstitutionNumber: 'Please make sure your institution number is correct!',
  paymentCheckboxTitle: '既定の払い出し方法',
  personalDataSubtitle: 'メールアドレス・郵便番号を変更する必要がある場合は、お手数ですが、カスタマーサービスまでご連絡ください。',
  withdrawConfirmation: '払い出し申請を確定する',
  addValidAccountNumber: '無効な口座番号です',
  adjustmentDescription: 'ｶｽﾀﾏｰｻｰﾋﾞｽによる調整',
  containerReUsed_other: 'あなたの返却個数<1>slotMachine</1> 使い捨て容器が削減されました！',
  deleteCheckboxConfirm: 'この操作は取り消すことができず、ずべてのデータが削除されることに同意します。',
  deleteHasBalanceTitle: 'Oops!',
  enterValidPhoneDigits: '電話番号の下4桁を入力してください',
  marketResearchConsent: 'Loop が市場調査の目的で私のデータを使用することを許可します',
  termsAndConditionsBtn: '利用規約とプライバシーポリシー',
  accountNumberTypeError: '無効な口座番号です',
  beforeWithdrawValidate: '払い出し申請にはメールアドレスの認証が必要です',
  contactCustomerSupport: 'メールアドレスの変更をご希望の場合は、弊社カスタマーサービスまでご連絡ください。',
  paymentDetailsSubtitle: '既定の預り金の払い出し先として設定されます',
  withdrawAmountOnConfrim: '払い出し金額',
  minimumWithdrawalAmmount: '払い出し手続きに必要な最低金額 {{value}}',
  deleteAccountRequestSucces: '削除リクエストを受け付けました。Loopからの連絡をお待ちください。',
}

const translation = {
  en,
  fr,
  ja,
}

export default translation
